// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"39a1d72064794862acee","339":"6cdedefcd70f107bc35b"}[chunkId] + ".js";
};